import { Component, ChangeDetectionStrategy, computed, input } from '@angular/core';
import {
  CampaignStatus,
  CAMPAIGN_STATUS_METADATA,
} from '@features/campaigns/models/campaign.model';

@Component({
  selector: 'app-campaign-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-md px-2 font-mono text-xs font-normal"
      [class]="meta().color"
    >
      <span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>
      {{ meta().label }}
    </span>
  `,
})
export class CampaignStatusBadge {
  status = input.required<CampaignStatus>();

  readonly meta = computed(() => {
    return (
      CAMPAIGN_STATUS_METADATA[this.status()] ??
      CAMPAIGN_STATUS_METADATA[CampaignStatus.DRAFT]
    );
  });
}
